'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _storageUtility = require('./storage-utility');

var _storageUtility2 = _interopRequireDefault(_storageUtility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SessionViews() {
  var timeToExtendSession = 180 * 60 * 1000; // Every view extends "session" for 3 hours
  var sessionViewsKey = 'session-views';
  this._storeSessionObj = function storeSessionObj(newViews) {
    var objToStore = {
      expiration: new Date().getTime() + timeToExtendSession,
      viewsThisSession: newViews
    };
    _storageUtility2.default.set(sessionViewsKey, JSON.stringify(objToStore));
  };
  this.increment = function increment() {
    var storageItem = _storageUtility2.default.get(sessionViewsKey);
    var viewsThisSession = 0;
    if (storageItem) {
      var existingSessionData = JSON.parse(storageItem);
      var hasExpired = new Date().getTime() > existingSessionData.expiration;
      if (!hasExpired) {
        viewsThisSession = existingSessionData.viewsThisSession;
      }
    }
    viewsThisSession++;
    this._storeSessionObj(viewsThisSession);
  };
  this.get = function get() {
    var existingSessionData = _storageUtility2.default.get(sessionViewsKey);
    if (existingSessionData) {
      var parsedSessionData = JSON.parse(existingSessionData);
      var hasExpired = new Date().getTime() > parsedSessionData.expiration;
      if (hasExpired) {
        this._storeSessionObj(0);
        return 0;
      }
      return JSON.parse(existingSessionData).viewsThisSession;
    }
    return 0;
  };
}

var sessionViews = new SessionViews();
exports.default = sessionViews;